import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedPermissions from './viewRelatedPermissions';
import viewRelatedUsers from './viewRelatedUsers';

export default {
  attributeName: 'id',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: false,
  emptyMessage: "No organizations available.",
  fields: [
    {
      attributeName: 'level',
      label: 'Level',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Level of permission',
      canEdit: true,
      canCreate: true,
      width: '12rem',
    },
  ],
};
